export default "__VITE_ASSET__DCctFT8Z__"